export const FIREBASE_EMAIL_EXISTS_ERR = 'auth/email-already-in-use';
